import { CATALOGICAL_ENDPOINT } from '../configuration/config';
import { BaseService } from './base-service';
import { StatusCodes } from 'http-status-codes';

export interface CompleteOrderCatalogInformation {
  licenseInstructions?: string;

  price?: number;

  productDownloadUrl?: string
}

export class CatalogicalService extends BaseService {
  /**
   * Singleton instance for catalogical service
   */
  public static instance = new CatalogicalService(CATALOGICAL_ENDPOINT);

  public async getCompleteOrderCatalogInformation(taxonomyId: string): Promise<CompleteOrderCatalogInformation> {
    const result: CompleteOrderCatalogInformation = {};
    const response = await this.fetch(`/item/${taxonomyId.replace("atn::", "")}`);
    if (response.status === StatusCodes.OK) {
      const jsonResponse = await response.json();
      if(jsonResponse.item === undefined) return result;
      const item = jsonResponse.item;
      result.licenseInstructions = item.licenseActivationInstructions;
      result.price = item.price?.amount;
      result.productDownloadUrl = item.references?.productDownloadUrl;
    }

    return result;
  }
}
